import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { BuilderProductGridInlineBanner } from "@faire/deprecated-retailer-visitor-shared/components/SignUpProductGridBanner/BuilderProductGridInlineBanner";
import { useSettingEnableDiscoverCategoryCTABanners } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableDiscoverCategoryCTABanners";
import { useSettingEnableLoggedOutDiscoverStoreTypeSection } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableLoggedOutDiscoverStoreTypeSection";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
import { useDiscoverPageFilteredProductGrids } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useDiscoverPageFilteredProductGrids";
import { useDiscoverPageAIContentPromise } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/DiscoverPageAIContentPromiseContextProvider";
import { useSearchPageParsedSearch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageParsedSearch";
import { useDiscoverPageShouldShowTopProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { trackSeoDiscoverPageFilteredProductGridsSeeAllClick } from "@faire/web-api--source/events/seo/click/discoverPageFilteredProductGridsSeeAll";
import { trackSeoDiscoverPageFilteredProductGridsViewView } from "@faire/web-api--source/events/seo/view/discoverPageFilteredProductGridsView";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { useResponsiveProp } from "@faire/web/ui/hooks/useResponsiveProp";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { use } from "react";
import { useLocation } from "react-router-dom";

import { DiscoverProductCarousel } from "../../SearchPageHeaderAndResults/DiscoverProductCarousel";

import { DiscoverStoreTypeSection } from "./DiscoverStoreTypeSection/DiscoverStoreTypeSection";

export const TOP_PRODUCTS_COUNT_BY_VIEWPORT: ResponsiveProp<number> = {
  mobileAndAbove: 8,
  desktopAndAbove: 10,
  xLargeAndAbove: 12,
};

export const TOP_PRODUCTS_COUNT_BY_VIEWPORT_WITH_SIDEBAR: ResponsiveProp<number> =
  {
    mobileAndAbove: 8,
    xLargeAndAbove: 10,
  };

export const DiscoverPageSectionalDesignWithStoreTypeXP = () => {
  const { pathname } = useLocation();
  const { filteredProductGrids, filteredProductGridsRequestId } =
    useDiscoverPageFilteredProductGrids();
  const aiContentPromise = useDiscoverPageAIContentPromise();
  const aiContent = aiContentPromise ? use(aiContentPromise) : undefined;

  const query = useSearchPageParsedSearch().q;
  const { data: searchProductsData } = useSearchPageQuery();
  const storeTypeSectionVariant =
    useSettingEnableLoggedOutDiscoverStoreTypeSection();

  const discoverCategoryCTABannersVariant =
    useSettingEnableDiscoverCategoryCTABanners();

  const shouldShowTopProducts = useDiscoverPageShouldShowTopProducts();
  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);

  const topProductsCountWithSidebar = useResponsiveProp(
    TOP_PRODUCTS_COUNT_BY_VIEWPORT_WITH_SIDEBAR
  );
  const topProductsCountWithoutSidebar = useResponsiveProp(
    TOP_PRODUCTS_COUNT_BY_VIEWPORT
  );
  const topProductsCount = isSideBarVisible
    ? topProductsCountWithSidebar
    : topProductsCountWithoutSidebar;

  const handleSeeAllClick = (title: string, ctaLink: string) => {
    trackSeoDiscoverPageFilteredProductGridsSeeAllClick(
      pathname,
      title,
      ctaLink
    );
  };

  if (filteredProductGrids.length === 0 && !shouldShowTopProducts) {
    return (
      <DiscoverStoreTypeSection
        query={query ?? ""}
        isPageWithFilter
        isSectionalDesign={false}
      />
    );
  }

  filteredProductGrids.forEach((filteredProductGrid) => {
    if (filteredProductGrid.filter_key === aiContent?.filtered_key1) {
      filteredProductGrid.title =
        aiContent?.filtered_section_header1 ?? filteredProductGrid.title;
    }
    if (filteredProductGrid.filter_key === aiContent?.filtered_key2) {
      filteredProductGrid.title =
        aiContent?.filtered_section_header2 ?? filteredProductGrid.title;
    }
  });

  return (
    <>
      <>
        {storeTypeSectionVariant === IThreeVariantXP.Bucket.VARIANT_3 ? (
          <DiscoverStoreTypeSection
            query={query ?? ""}
            isPageWithFilter
            isSectionalDesign
          />
        ) : (
          <Spacer height="3x" />
        )}
        <SectionHeader>
          <StrictLocalMsg
            id="RJX4G/"
            defaultMessage="Top products in {queryFullyTranslatedSentence}"
            description={{
              text: "Header for a product grid",
              img: "https://cdn.faire.com/fastly/64f56536549126e54f02232488f54398578b4c2030b029938da5b27a8cab41b7.png",
            }}
            values={{
              queryFullyTranslatedSentence: query ?? "",
            }}
          />
        </SectionHeader>
        <Spacer height="3x" />
        <DiscoverProductCarousel
          products={
            searchProductsData?.product_tiles?.slice(0, topProductsCount) ?? []
          }
          brandMap={searchProductsData?.brands_by_token}
          requestId={searchProductsData?.request_id}
        />
        <Spacer height="3x" />
        {storeTypeSectionVariant === IThreeVariantXP.Bucket.VARIANT_2 ? (
          <DiscoverStoreTypeSection
            query={query ?? ""}
            isPageWithFilter
            isSectionalDesign
          />
        ) : null}
        <BuilderProductGridInlineBanner
          bannerModelName={
            discoverCategoryCTABannersVariant ===
            IThreeVariantXP.Bucket.VARIANT_3
              ? "category-discover-first-inline-banner"
              : undefined
          }
        />
        <Spacer height="3x" />
      </>
      {filteredProductGrids.map((filteredProductGrid, index) => (
        <ViewEventWrapper
          key={filteredProductGrid.title}
          title={filteredProductGrid.title ?? ""}
          position={index}
        >
          <SectionHeader>{filteredProductGrid.title}</SectionHeader>
          <Spacer height="3x" />
          {filteredProductGrid.cta_link ? (
            <SectionalCTAButton
              title={filteredProductGrid.title ?? ""}
              ctaLink={filteredProductGrid.cta_link}
              handleSeeAllClick={handleSeeAllClick}
            />
          ) : null}
          <DiscoverProductCarousel
            products={filteredProductGrid.product_tiles}
            brandMap={filteredProductGrid.brand_by_token}
            requestId={filteredProductGridsRequestId}
          />
          <Spacer height="6x" />
        </ViewEventWrapper>
      ))}
      <SectionHeader>
        <StrictLocalMsg
          id="8zjOvb"
          defaultMessage="All products in {queryFullyTranslatedSentence}"
          description={{
            text: "Header for all products matching a search query",
            img: "https://cdn.faire.com/fastly/5ca8a21a946143fb6b23ba5fd3cba8632dec3f411399acbb8c9dce3c00ef4106.png",
          }}
          values={{
            queryFullyTranslatedSentence: query ?? "",
          }}
        />
      </SectionHeader>

      <Spacer height="1x" />
    </>
  );
};

const SectionalCTAButton = ({
  title,
  ctaLink,
  handleSeeAllClick,
}: {
  title: string;
  ctaLink: string;
  handleSeeAllClick: (title: string, ctaLink: string) => void;
}) => {
  return (
    <div className="absolute top-1.5 right-2 md:top-4">
      <Button
        variant="tertiary"
        linkTo={ctaLink}
        onClick={() => handleSeeAllClick(title, ctaLink)}
      >
        <StrictLocalMsg
          id="zVw1r+"
          defaultMessage="See all"
          description={{
            text: "CTA button to click on to see all products in a category",
            img: "https://cdn.faire.com/fastly/c5d5837c88dd84ca7abbfab839335377bdc5acaa15771b4e687923176f3650f0.png",
          }}
        />
      </Button>
    </div>
  );
};

export const SectionHeader: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <Typography
      className="pl-2!"
      as="h2"
      variant={{
        mobileAndAbove: "pageHeaderSerifRegular",
        desktopAndAbove: "displaySSerifRegular",
      }}
    >
      {children}
    </Typography>
  );
};

const ViewEventWrapper: React.FC<{
  title: string;
  position: number;
  children: React.ReactNode;
}> = ({ title, position, children }) => {
  const { pathname } = useLocation();
  const viewRef = useDoActionWhenVisible(() => {
    trackSeoDiscoverPageFilteredProductGridsViewView(
      pathname,
      title,
      `${position}`
    );
  });

  return (
    <div className="relative" ref={viewRef}>
      {children}
    </div>
  );
};
